import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const NoDataMessage = ({ date }) => {
    return (_jsx("div", { className: "flex items-center justify-center h-full p-5 border border-gray-300 shadow-md text-xl text-center", "data-test": "no-data-available-content", children: date ? `No Data Available for ${date}` : `No Data Available` }));
};
export default NoDataMessage;
